import { Injectable } from '@angular/core';
import { Enrollee } from '../interfaces/enrollee';
import { Countries } from 'src/app/enums/countries';
import { CustomerType } from '../enums/customer-type';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, catchError, map, takeUntil } from 'rxjs';
import { UserType } from '../enums/user-type';
import { User } from '../interfaces/user';

@Injectable({
     providedIn: 'root'
})
export class EnrollmentService {
     newCustomer: Enrollee | undefined;
     powerUser: User | undefined;
     billingUser: User | undefined;
     users: User[] | undefined;
     billingUserSame:string = 'true';
     billingEmail:string = '';
     discoveredViaOther:string = ''
     billingState: string = 'get';
     inProcess: boolean = false;

     //we need to hold onto this info after the new customer gets cleared out.
     
     customerId:string = '';
     PrimaryContactEmail:string = '';
     contactName:string = '';
     contactPhone: string = '';
     companyName: string = '';

     foundDupEmails:boolean = false;
     EnrolledError:boolean = false;
     calls = new Subject();


     constructor(private http: HttpClient) {
          const customerInLocalMemory = this.loadFromLocal();
          if(customerInLocalMemory === false){
               this.clearCustomer();
          }
     }

     public clearCustomer(){
          this.newCustomer = this.iniCustomer();
          this.clearPower();
          this.iniBillingUser();
          this.cleanUsers();
          this.billingUserSame = 'true';
          this.EnrolledError = false;
     }

     public clearPower() {
          this.powerUser = { firstName: '', lastName: '', address: null, primaryPhoneNumber: '', faxNumber: '', email: '', isAdmin: true, userType: UserType.PowerUser }
     }

     public iniBillingUser() {
          this.billingUser = { firstName: '', lastName: '', address: null, primaryPhoneNumber: '', faxNumber: '', email: '', isAdmin: false, userType: UserType.BillingUser };
     }

     public cleanUsers() {
          this.users = [];
     }
     public addUser(){
          this.users?.push({ firstName: '', lastName: '', address: null, primaryPhoneNumber: '', faxNumber: '', email: '', isAdmin: false, userType: UserType.StandardUser });
     }

     private iniCustomer() {
          const newCustomer: Enrollee = {
               name: '',
               address: { addressLine1: '', addressLine2: '', city: '', country: '', countryId: Countries.NA, state: '', zip: '' },
               city: '',
               country: Countries.NA,
               state: '',
               zip: '',
               phoneNumber: '',
               faxNumber: '',
               users: [],
               billingInfo: { firstName: '', lastName: '', address: null, phoneNumber: '', contactEmailId: '', billType: 'Checking', bankName: null, routingNumber: null, accountNumber: null },
               dotId: '',
               numberOfPowerUnits: undefined,
               customerType: CustomerType.NA,
               customerTypeDisplayValue: 'Administration',
               powerUser: '',
               powerUserEmail: '',
               cdbPrimaryContactEmail: '',
               cdbPrimaryContactPhone: '',
               cdbPrimaryContactFirstName: '',
               cdbPrimaryContactLastName: '',
               interIntraState: '',
               motorPassengerCarrier: '',
               discoveredPspVia: '',
               primaryBillingAreSame: true,
               paymentMethod: 'Pending',
               finalConsent: {agreesToConsent:'---'},
               eulaAgreement: { agentFirstName: '', readDisclosure: '', agentLastName: '', agentTitle: '', readAgreement: '', readCerts: '' },
               status: {appicanStatus:null,updateBy:null,updateDate:null},
               consentName: '',
               consentTitle: '',
               ispAnnualScreenings: undefined,
               ispEstimatedCustomers: undefined
          }
          return newCustomer;
     }


     testDOT(dotnumber: string): Observable<any> {
          const url: string = `${environment.APP_API_URL}/api/v1/Customers/DotNumberExists?dotNumber=` + dotnumber;
          return this.http.get(url, { responseType: 'text' })
               .pipe(
                    map((response: any) => response),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );
     }

     testEmail(emailString: string): any {
          if (emailString) {
               const url: string = `${environment.APP_API_URL}/api/v1/Applicant/doesEmailExist/${emailString}`;
               return this.http.get(url, { responseType: 'text' })
                    .pipe(
                         map((response: any) => response),
                         catchError(error => {
                              console.error(error);
                              return [];
                         })
                    );
          } else {
               return [];
          }
     }

     getCountries(): Observable<any> {
          const url: string = `${environment.APP_API_URL}/api/v1/Geography/getCountries`;
          return this.http.get(url)
               .pipe(
                    map((response: any) =>
                         response as []),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );
     }

     getStates(): Observable<any> {
          const url: string = `${environment.APP_API_URL}/api/v1/Geography/getStates?country=${this.newCustomer!.country}`;
          return this.http.get(url)
               .pipe(
                    map((response: any) =>
                         response as []),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );
     }

     clearLocal(){
          localStorage.removeItem('myDataKey');
     }

     clearAll(){
          localStorage.removeItem('myDataKey');
          this.clearCustomer();
          this.billingUserSame = 'true';
          this.billingEmail = '';
          this.discoveredViaOther = ''
          this. billingState = 'get';
     
          this.customerId = '';
          this.PrimaryContactEmail = '';
          this.contactName = '';
          this.contactPhone = '';
          this.companyName = '';
          this.inProcess = false;
     }

     saveToLocal(){
          if(environment.NODE_ENV === "" || environment.NODE_ENV === 'qa'){
               localStorage.setItem('myDataKey', JSON.stringify({all:this.newCustomer,power:this.powerUser,billing:this.billingUser,billingUserSame:this.billingUserSame, users:this.users}));
          }
     }

     loadFromLocal(){
          if(environment.NODE_ENV !== "" ){
               return false;
          }
          const localInfo = localStorage.getItem('myDataKey') || null;
          if(localInfo !== null){
               const local_ = JSON.parse(localInfo);
               this.newCustomer = local_.all;
               this.powerUser = local_.power;
               this.billingUser = local_.billing;
               this.users = local_.users;
               this.billingUserSame = local_.billingUserSame;
               return true;
          }else{
               return false;
          }
     }

     //#region save payment work
     save(): any {
          //we need to clean up a few things. and distribute data to all the needed places
          this.powerUser!.primaryPhoneNumber = this.cleanNumber(this.powerUser!.primaryPhoneNumber);
          this.powerUser!.faxNumber = this.cleanNumber(this.powerUser!.faxNumber !== '' ? this.powerUser!.faxNumber  : '');

          this.newCustomer!.address!.country = this.newCustomer!.country!.toString() ;
          this.newCustomer!.address!.countryId = parseInt(Countries[this.newCustomer!.country!]);  

          this.newCustomer!.city = this.newCustomer!.address!.city;
          this.newCustomer!.state = this.newCustomer!.address!.state;
          this.newCustomer!.zip = this.newCustomer!.address!.zip;
          this.newCustomer!.phoneNumber = this.powerUser!.primaryPhoneNumber;
          this.newCustomer!.faxNumber = this.powerUser!.faxNumber;

          this.newCustomer!.powerUserEmail = this.powerUser?.email;
          this.newCustomer!.cdbPrimaryContactEmail = this.powerUser?.email;
          this.newCustomer!.cdbPrimaryContactPhone = this.powerUser?.primaryPhoneNumber;
          this.newCustomer!.cdbPrimaryContactFirstName = this.powerUser?.firstName;
          this.newCustomer!.cdbPrimaryContactLastName = this.powerUser?.lastName;

          this.newCustomer!.powerUser = this.powerUser?.firstName + " " + this.powerUser?.lastName;

          //we hold the email here because we need it after enrollment is a success. We use it in a message back to the customer
          this.PrimaryContactEmail =this.powerUser!.email;

          this.newCustomer!.users?.push(this.powerUser!);

          if(this.billingUserSame === "false"){
               this.newCustomer!.primaryBillingAreSame = false;
               this.billingUser!.primaryPhoneNumber = this.cleanNumber(this.billingUser!.primaryPhoneNumber);
               this.billingUser!.faxNumber = this.cleanNumber(this.billingUser!.faxNumber !== '' ? this.billingUser!.faxNumber  : '');
               this.newCustomer!.users?.push(this.billingUser!);
               this.newCustomer!.billingInfo!.firstName = this.billingUser!.firstName;
               this.newCustomer!.billingInfo!.lastName = this.billingUser!.lastName;
               this.newCustomer!.billingInfo!.contactEmailId = this.billingUser!.email;
               this.newCustomer!.billingInfo!.phoneNumber = this.billingUser!.primaryPhoneNumber;
         
          }else{
               this.newCustomer!.primaryBillingAreSame = true;
               this.newCustomer!.billingInfo!.firstName = this.powerUser!.firstName;
               this.newCustomer!.billingInfo!.lastName = this.powerUser!.lastName;
               this.newCustomer!.billingInfo!.contactEmailId = this.powerUser!.email;
               this.newCustomer!.billingInfo!.phoneNumber = this.powerUser!.primaryPhoneNumber;
          }
          //I need to hold this for wallet.
          this.billingEmail = this.powerUser!.email;
          this.contactName = this.powerUser!.firstName + " " + this.powerUser!.lastName;
          this.contactPhone = this.powerUser!.primaryPhoneNumber;
          this.companyName = this.newCustomer!.name!;
        
          if(this.users!.length > 0){
               this.newCustomer!.users = this.newCustomer!.users!.concat(this.users!);
          }

          this.newCustomer!.consentTitle = this.newCustomer?.eulaAgreement?.agentTitle;
          this.newCustomer!.consentName = this.newCustomer?.eulaAgreement?.agentFirstName + ' ' + this.newCustomer?.eulaAgreement?.agentLastName;
          if(this.newCustomer?.discoveredPspVia === "Other"){
               this.newCustomer.discoveredPspVia = this.discoveredViaOther;
          }

          //now we are ready to save;
          const url: string = `${environment.APP_API_URL}/api/v1/Customers/EnrollNewCustomer`;
          this.calls.next(true);
          return this.http.post(url,this.newCustomer)
               .pipe(
                    takeUntil(this.calls),
                    map((response: any) =>
                         response as any),
                    catchError(error => {
                         return ['false'];
                    })
               );
      }

      private cleanNumber(val: string): string {
          val = val.replace('(', '')
          val = val.replace(')', '')
          val = val.replace('', '')
          val = val.replace('-', '')
          val = val.replace(' ', '')
          return val;
  
      }
     //#region 

     
    


}
